<template>
  <div class="mt-2 text-xs text-red-500">
    <slot></slot>
  </div>
</template>
